import { useState } from "react";
import { Bell, Briefcase, CalendarPlus, Coffee, MessageCircle, Stethoscope, Users } from "lucide-react";

// Палитра как у баннера консьержа: ночная бирюза, янтарь, крем
const BG = "linear-gradient(135deg, #002C2B 0%, #004F4E 100%)";
const AMBER = "#C9893A";
const CREAM = "#F0EDE6";
const CHAMPAGNE = "#E8DCC8";
const DEEP = "#002C2B";
const IMG = "/assets/prive-concierge.webp";

const TILES = [
  { icon: Bell, text: "Афиша по твоим интересам и уведомления о новом в городе" },
  { icon: Users, text: "Сообщества по интересам" },
  { icon: Coffee, text: "Знакомства и кофе" },
  { icon: Stethoscope, text: "Каталог экспертов: врачи, юристы, мастера на русском" },
  { icon: MessageCircle, text: "Спроси своих: вопрос сообществу и живые ответы" },
  { icon: Briefcase, text: "Работа, подрядчики и барахолка" },
  { icon: CalendarPlus, text: "Размести своё событие или услугу", wide: true },
];

function Cat({ size }: { size: number }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <span className="shrink-0 rounded-full p-[2px]" style={{ background: AMBER, width: size + 4, height: size + 4 }}>
      <img decoding="async" src={IMG} alt="" width={size} height={size} onError={() => setFailed(true)} className="h-full w-full rounded-full object-cover" loading="lazy" />
    </span>
  );
}

/** Постоянный блок-приглашение для гостей афиши. Не закрывается, без пауз. */
export function GuestInviteBlock({ onSignup, onLogin, className }: {
  onSignup: () => void;
  onLogin: () => void;
  className?: string;
}) {
  return (
    <section
      aria-label="Приглашение в TurkeyDrive"
      className={`relative min-w-0 overflow-hidden rounded-3xl border p-4 sm:p-5 ${className ?? ""}`}
      style={{ backgroundImage: BG, borderColor: "rgba(201,137,58,0.5)" }}
    >
      <div className="flex items-center gap-3">
        <Cat size={56} />
        <div className="min-w-0">
          <h2 className="break-words font-serif text-xl font-bold leading-tight" style={{ color: CREAM }}>
            Стань своим в TurkeyDrive
          </h2>
          <p className="mt-1 break-words text-[13px] leading-snug" style={{ color: CHAMPAGNE }}>
            Афиша это только вход. Внутри всё для жизни в Турции
          </p>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-2">
        {TILES.map(({ icon: Icon, text, wide }) => (
          <div
            key={text}
            className={`flex min-w-0 items-start gap-2 rounded-xl p-2.5 ${wide ? "col-span-2" : ""}`}
            style={{ background: "rgba(240,237,230,0.08)" }}
          >
            <Icon className="mt-0.5 h-4 w-4 shrink-0" style={{ color: AMBER }} aria-hidden />
            <span className="break-words text-[12px] leading-snug" style={{ color: CREAM }}>{text}</span>
          </div>
        ))}
      </div>

      <button
        type="button"
        onClick={onSignup}
        className="mt-4 flex h-12 w-full items-center justify-center rounded-full bg-td-orange text-base font-semibold text-white hover:bg-td-orange/90"
      >
        Зарегистрироваться
      </button>
      <button
        type="button"
        onClick={onLogin}
        className="mt-1 flex min-h-11 w-full items-center justify-center text-[13px]"
        style={{ color: CHAMPAGNE }}
      >
        Уже есть профиль? <span className="ml-1 font-semibold underline" style={{ color: AMBER }}>Войти</span>
      </button>
    </section>
  );
}
